import type { Account } from "~/v2/api/rest/account";
import type { SelectedContract } from "~/v2/pages/dashboard/tradeV2";
import { isGTZero } from "../shared/utils";
import type { MultiLegOrderSchema } from "./schema";

export type CombinedLeg = {
  form: MultiLegOrderSchema["legs"][number];
  data: SelectedContract;
};

export const combineLegs = (
  propLegs: readonly SelectedContract[],
  formLegs: MultiLegOrderSchema["legs"],
): CombinedLeg[] =>
  propLegs
    .map((propLeg) => ({
      data: propLeg,
      form: formLegs.find(
        (formLeg) => formLeg.symbol === propLeg.contract.symbol,
      ),
    }))
    .filter(({ form }) => !!form) as CombinedLeg[];

export const getIsMultiLegSubmitDisabled = ({
  isSubmitCompleted,
  account,
  product,
  formLegs,
  quantity,
  orderType,
  limitPrice,
}: {
  isSubmitCompleted: boolean;
  account: Account | undefined;
  product: string | undefined;
  formLegs: MultiLegOrderSchema["legs"];
  quantity: number;
  orderType: MultiLegOrderSchema["orderType"];
  limitPrice: number | undefined;
}): boolean => {
  if (
    isSubmitCompleted ||
    !account ||
    !product ||
    !formLegs.length ||
    !isGTZero(quantity) ||
    formLegs.some(({ ratioQty }) => !isGTZero(ratioQty))
  ) {
    return true;
  }
  if (
    orderType === "limit" &&
    (limitPrice === undefined || Number.isNaN(limitPrice))
  ) {
    return true;
  }
  return false;
};
